<script setup lang="ts">
import ProductsTable from '../../components/ProductsComponents/Table/ProductsTable.vue'
</script>

<template>
    <ProductsTable />
</template>
